// eslint-disable-next-line no-restricted-imports
import {
	useSelector as useSelectorOriginal,
	type TypedUseSelectorHook,
	useDispatch as useDispatchOriginal,
} from 'react-redux';
import { type RootState, type AppDispatch } from 'app/store';

// define types
const useSelector: TypedUseSelectorHook<RootState> = useSelectorOriginal;
const useDispatch = () => useDispatchOriginal<AppDispatch>();

// eslint-disable-next-line no-restricted-imports
export * from 'react-redux';

// override method
export { useSelector, useDispatch };
